interface Data {
  date: string;
  order_id: number;
  details: string;
  amount: number;
  action: any;
}

interface HeadCell {
  disablePadding: boolean;
  id: keyof Data;
  label: string;
  numeric: boolean;
}

export const tableHeadData: readonly HeadCell[] = [
  {
    id: "date",
    numeric: false,
    disablePadding: true,
    label: "DATE",
  },
  {
    id: "order_id",
    numeric: true,
    disablePadding: false,
    label: "ORDER ID",
  },
  {
    id: "details",
    numeric: true,
    disablePadding: false,
    label: "DETAILS",
  },
  {
    id: "amount",
    numeric: true,
    disablePadding: false,
    label: "AMOUNT",
  },
  {
    id: "action",
    numeric: true,
    disablePadding: false,
    label: "ACTION",
  },
];

export const statementData = [
  {
    id: 1,
    amount: 168,
    date: "29/06/2021",
    order_id: 35032056,
    details: "Lorem ipsum is text commonly",
  },
  {
    id: 2,
    amount: 233,
    date: "21/02/2021",
    order_id: 31508639,
    details: "Lorem ipsum is text commonly",
  },
  {
    id: 3,
    amount: 117,
    date: "06/07/2021",
    order_id: 28321611,
    details: "Lorem ipsum is text commonly",
  },
  {
    id: 4,
    amount: 276,
    date: "06/04/2021",
    order_id: 29263584,
    details: "Lorem ipsum is text commonly",
  },
  {
    id: 5,
    amount: 280,
    date: "21/06/2021",
    order_id: 33626134,
    details: "Lorem ipsum is text commonly",
  },
  {
    id: 6,
    amount: 266,
    date: "03/09/2021",
    order_id: 32934848,
    details: "Lorem ipsum is text commonly",
  },
  {
    id: 7,
    amount: 138,
    date: "10/04/2021",
    order_id: 35694649,
    details: "Lorem ipsum is text commonly",
  },
  {
    id: 8,
    amount: 249,
    date: "14/07/2021",
    order_id: 34469346,
    details: "Lorem ipsum is text commonly",
  },
  {
    id: 9,
    amount: 78,
    date: "22/12/2020",
    order_id: 28327133,
    details: "Lorem ipsum is text commonly",
  },
  {
    id: 10,
    amount: 211,
    date: "21/11/2020",
    order_id: 28361367,
    details: "Lorem ipsum is text commonly",
  },
  {
    id: 11,
    amount: 43,
    date: "10/07/2021",
    order_id: 35986229,
    details: "Lorem ipsum is text commonly",
  },
  {
    id: 12,
    amount: 267,
    date: "28/07/2021",
    order_id: 36434539,
    details: "Lorem ipsum is text commonly",
  },
  {
    id: 13,
    amount: 159,
    date: "20/08/2021",
    order_id: 31882693,
    details: "Lorem ipsum is text commonly",
  },
  {
    id: 14,
    amount: 79,
    date: "19/01/2021",
    order_id: 26970468,
    details: "Lorem ipsum is text commonly",
  },
  {
    id: 15,
    amount: 278,
    date: "09/02/2021",
    order_id: 32540319,
    details: "Lorem ipsum is text commonly",
  },
  {
    id: 16,
    amount: 235,
    date: "27/12/2020",
    order_id: 32263319,
    details: "Lorem ipsum is text commonly",
  },
  {
    id: 17,
    amount: 155,
    date: "23/02/2021",
    order_id: 27876195,
    details: "Lorem ipsum is text commonly",
  },
  {
    id: 18,
    amount: 250,
    date: "25/07/2021",
    order_id: 35134854,
    details: "Lorem ipsum is text commonly",
  },
  {
    id: 19,
    amount: 285,
    date: "27/07/2021",
    order_id: 29747442,
    details: "Lorem ipsum is text commonly",
  },
  {
    id: 20,
    amount: 299,
    date: "11/12/2020",
    order_id: 27412174,
    details: "Lorem ipsum is text commonly",
  },
];
